module.exports = __webpack_public_path__ + "img/logo.61ee7293.svg";